// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.os-cell-container[data-v-e88dcfd4]{display:inline-flex}`, "",{"version":3,"sources":["webpack://./client/components/TableCells/TableCellListOperatingSystems.vue"],"names":[],"mappings":"AAGA,oCACE,mBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
